import React, {Component} from 'react';
import ListComponent from "./ListComponent";
import PropTypes from 'prop-types';

const paginate = (items,page,limit) => {

    if(page >= 1 && limit > 0){

        let index = (page - 1) * limit;
        let end =  Math.min( index + limit, items.length ) ;

        let results = [];
        while(index < end)
            results.push(items[index++]);

        return results;

    }

    return items;
};

class DataList extends Component {

    static propTypes = {
        itemsPerPage: PropTypes.number,
        data: PropTypes.array,
        queryData: PropTypes.func,
        columns: PropTypes.array,
        responsive: PropTypes.bool,
        striped: PropTypes.bool,
        hover: PropTypes.bool,
        rowActions: PropTypes.array,
        noRowsMessage: PropTypes.string,
        onRowClick: PropTypes.func,
        listRef: PropTypes.func,
        formatValue: PropTypes.func,
        getRowClass: PropTypes.func,
        defaultRowClass: PropTypes.string
    };

    static defaultProps = {
        noRowsMessage: "No items available",
        hover: true,
        rowActions: [],
        formatValue: (value,format) => value
    };

    constructor(props){
        super(props);

        this.state = {
            currentPage: 1,
            itemsPerPage: props.itemsPerPage
        };

        this.onQueryItems = this.onQueryItems.bind(this);
    }

    async onQueryItems({ page, limit }){

        const { data } = this.props;

        if(data === undefined && this.props.queryData){
            const { items , count } = await this.props.queryData(page,limit,{ paginate });
            return { items , totalItems: count };
        }
        else{
            return { items: paginate(data || [],page,limit) , totalItems: data.length };
        }

    }

    /**
     * Refresh underlying list
     * @return {*}
     */
    refresh = () => this._list.refresh();

    render(){

        return <ListComponent ref={r => {
                                this._list = r;
                                if(this.props.listRef)
                                    this.props.listRef(r);
                              }}
                              columns={this.props.columns}
                              rowActions={this.props.rowActions}
                              paginate={true}
                              getItemsPaginated={this.onQueryItems}
                              noRowsMessage={this.props.noRowsMessage}
                              page={this.state.currentPage}
                              getRowClass={this.props.getRowClass}
                              defaultRowClass={this.props.defaultRowClass}
                              limit={this.state.itemsPerPage}
                              onRowClick={this.props.onRowClick}
                              formatValue={this.props.formatValue}
                              onPaginationChange={(page,limit) => {

                                  if(page !== this.state.currentPage) {

                                      this.setState({
                                          currentPage: page,
                                          itemsPerPage: limit
                                      }, () =>{
                                          this._list.refresh();
                                      });

                                  }

                              }}
                              hover={this.props.hover}
                              striped={this.props.striped}
                              responsive={this.props.responsive}/>

    }

}

export default  DataList;



// WEBPACK FOOTER //
// ./src/components/TableListView/DataList.js